var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddToCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_2_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 728.5 708.8",
    style: {
      enableBackground: "new 0 0 728.5 708.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B81D21;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "cross_white",
    className: "st0",
    d: "M547.6,160h-74.7v-73c0-10.9-8.9-19.8-19.8-19.8s-19.8,8.9-19.8,19.8v73h-75.4 c-10.9,0-19.8,8.9-19.8,19.8c0,10.9,8.9,19.8,19.8,19.8h75.4v77c0,10.9,8.9,19.8,19.8,19.8s19.8-8.9,19.8-19.8v-77h74.6 c10.9,0,19.8-8.9,19.8-19.8C567.2,168.9,558.4,160,547.6,160z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M723.8,160.7c-3.1-3.8-7.8-6-12.7-6h-83.7C614.3,68.4,539.5,2,449.6,2C359.7,2,285,68.4,271.9,154.7h-152 l-17.1-62.9c-2-7.2-8.5-12.2-15.9-12.2H18.6C9.4,79.6,2,87,2,96.1s7.4,16.5,16.5,16.5h55.6l17,62.3l56.8,293.5 c1.2,6.1,5.6,10.8,11.3,12.6c-4.6,8.4-7.1,18.2-7.1,28.9c0,31.6,21.1,52.5,55.8,56.6c-18.5,14.6-30.4,37.2-30.4,62.5 c0,43.9,35.7,79.6,79.6,79.6c43.9,0,79.6-35.7,79.6-79.6c0-24.9-11.5-47.1-29.5-61.8h199.1c-18,14.6-29.5,36.9-29.5,61.8 c0,43.9,35.7,79.6,79.6,79.6c43.9,0,79.6-35.7,79.6-79.6c0-24.9-11.5-47.1-29.5-61.8h43.2c9.1,0,16.5-7.4,16.5-16.5 c0-9.1-7.4-16.5-16.5-16.5H220.9c-23.8,0-35.8-8.2-35.8-24.3c0-20.8,18.5-28.2,35.8-28.2h433.3c7.9,0,14.7-5.6,16.2-13.4 l56.9-294.1C728.2,169.5,727,164.6,723.8,160.7z M556.4,579.6c27.3,0,49.5,22.2,49.5,49.5c0,27.3-22.2,49.5-49.5,49.5 s-49.5-22.2-49.5-49.5C506.9,601.9,529.1,579.6,556.4,579.6z M257,579.6c27.3,0,49.5,22.2,49.5,49.5c0,27.3-22.2,49.5-49.5,49.5 s-49.5-22.2-49.5-49.5C207.5,601.9,229.7,579.6,257,579.6z M304.9,154.7c12.7-68.4,72.6-120.2,144.7-120.2s132,51.8,144.7,120.2 c1.6,8.8,2.5,17.8,2.5,27c0,2-0.1,4-0.1,6c-3.2,78.5-67.8,141.2-147.1,141.2s-143.9-62.7-147.1-141.2c-0.1-2-0.1-4-0.1-6 C302.4,172.5,303.3,163.5,304.9,154.7z M640.6,448.9H220.9h-43.1l-50.5-261.1H270c3.2,96.3,82.5,173.7,179.6,173.7 c97.1,0,176.4-77.4,179.6-173.7H691L640.6,448.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToCart);
export default __webpack_public_path__ + "static/media/addToCart.4e7e3b89.svg";
export { ForwardRef as ReactComponent };